<script>
    import { onMount } from "svelte";

    function baseTarget() {
        document.body.addEventListener(
            "click",
            function (e) {
                // e.target was the clicked element
                if (e.target && e.target.nodeName == "A") {
                    e.target.target = "_blank";
                }
            },
            true,
        );
    }
    onMount(() => {
        baseTarget();
    });
</script>

<svelte:head>
    <link href="/style.css" rel="stylesheet" />
</svelte:head>
<div class="app">
    <slot />
</div>

<style>
    .app {
        background-color: var(--app-background);
        min-height: 100vh;
        padding: 1rem;
    }
</style>
